// extracted by mini-css-extract-plugin
export default {"referral-widget":"on","referral-page":"pn","label":"qn","subHed":"rn","profile-container":"sn","referral-container":"tn","referral-header":"un","shareMethodRow":"vn","shareMethod":"wn","active":"xn","referral-stat":"yn","blockwrapper":"zn","referralLink":"An","bold":"Bn","semibold":"Cn","shareAgainButton":"En","policy":"Fn","narrowWrapper":"Gn"};
    if(module.hot) {
      // 1715188229248
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  